import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api'; 

class ProviderService {
  // Szolgáltatók listázása
  async getProviders(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category) queryParams.append('category', params.category);
      if (params.city) queryParams.append('city', params.city);
      if (params.county) queryParams.append('county', params.county); // ÚJ: megye szűrő
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
      if (params.seed) queryParams.append('seed', params.seed); // véletlenszerű rendezés seed-je
      if (params.status) queryParams.append('status', params.status);
      if (params.minPrice) queryParams.append('minPrice', params.minPrice);
      if (params.maxPrice) queryParams.append('maxPrice', params.maxPrice);
      
      const response = await apiService.get(`/providers?${queryParams.toString()}`);
      return response;
    } catch (error) {
      console.error('Szolgáltatók lekérése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató részleteinek lekérése
  async getProviderDetails(providerId) {
    try {
      const response = await apiService.get(`/providers/${providerId}`);
      return response;
    } catch (error) {
      console.error('Szolgáltató részletek lekérése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató profil frissítése
  async updateProvider(providerId, providerData) {
    try {
      const response = await apiService.put(`/providers/${providerId}`, providerData);
      return response;
    } catch (error) {
      console.error('Szolgáltató frissítése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató regisztrációja
  async registerProvider(providerData) {
    try {
      const response = await apiService.post('/providers/register', providerData);
      return response;
    } catch (error) {
      console.error('Szolgáltató regisztráció hiba:', error);
      throw error;
    }
  }

  // Szolgáltató státusz frissítése (admin)
  async updateProviderStatus(providerId, status, notes = '') {
    try {
      const response = await apiService.put(`/providers/${providerId}/status`, {
        status,
        notes
      });
      return response;
    } catch (error) {
      console.error('Szolgáltató státusz frissítése hiba:', error);
      throw error;
    }
  }

  // Profil-teljesség (admin ellenőrzési szempontok: képek, ár, leírás, ...)
  async getCompleteness(providerId) {
    const response = await apiService.get(`/providers/${providerId}/completeness`);
    return response?.data;
  }

  // Szolgáltató beküldi admin jóváhagyásra a piszkozat profilját
  async confirmProvider(providerId) {
    try {
      const response = await apiService.post(`/providers/${providerId}/confirm`);
      return response;
    } catch (error) {
      console.error('Szolgáltató profil jóváhagyása hiba:', error);
      throw error;
    }
  }

  // Szolgáltató statisztikák
  async getProviderStats(providerId) {
    try {
      const response = await apiService.get(`/providers/${providerId}/stats`);
      return response;
    } catch (error) {
      console.error('Szolgáltató statisztikák lekérése hiba:', error);
      throw error;
    }
  }

  // Saját szolgáltató adatok (bejelentkezett szolgáltató)
  async getMyProvider() {
    try {
      const response = await apiService.get('/providers/me');
      return response;
    } catch (error) {
      console.error('Saját szolgáltató adatok lekérése hiba:', error);
      throw error;
    }
  }

  // Saját szolgáltató statisztikák
  async getMyStats() {
    try {
      const response = await apiService.get('/providers/me/stats');
      return response;
    } catch (error) {
      console.error('Saját statisztikák lekérése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató keresése
  async searchProviders(searchTerm, filters = {}) {
    try {
      const params = {
        search: searchTerm,
        ...filters
      };
      
      const response = await this.getProviders(params);
      return response;
    } catch (error) {
      console.error('Szolgáltató keresése hiba:', error);
      throw error;
    }
  }

  // Népszerű szolgáltatók
  async getPopularProviders(limit = 10) {
    try {
      const response = await apiService.get(`/providers/popular?limit=${limit}`);
      return response;
    } catch (error) {
      console.error('Népszerű szolgáltatók lekérése hiba:', error);
      throw error;
    }
  }

  // Közeli szolgáltatók
  async getNearbyProviders(city, limit = 10) {
    try {
      const response = await apiService.get(`/providers/nearby?city=${city}&limit=${limit}`);
      return response;
    } catch (error) {
      console.error('Közeli szolgáltatók lekérése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató elérhetőségének ellenőrzése
  async checkAvailability(providerId, date, time) {
    try {
      const response = await apiService.get(`/providers/${providerId}/availability?date=${date}&time=${time}`);
      return response;
    } catch (error) {
      console.error('Elérhetőség ellenőrzése hiba:', error);
      throw error;
    }
  }

  // Közeli szolgáltatók lekérése (frontend oldali hívás)
  async getNearbyProviders(latitude, longitude, radius = 20, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('latitude', latitude);
      queryParams.append('longitude', longitude);
      queryParams.append('radius', radius);

      // További szűrők hozzáadása
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.category) queryParams.append('category', params.category);
      if (params.minPrice) queryParams.append('minPrice', params.minPrice);
      if (params.maxPrice) queryParams.append('maxPrice', params.maxPrice);
      if (params.minRating) queryParams.append('minRating', params.minRating);
      if (params.status) queryParams.append('status', params.status);

      // API_ENDPOINTS használata
      const response = await apiService.get(`${API_ENDPOINTS.PROVIDERS.NEARBY}?${queryParams.toString()}`);
      return response;
    } catch (error) {
      console.error('Közeli szolgáltatók lekérése hiba:', error);
      throw error;
    }
  }

  // Szolgáltató munkaidő beállítása
  async updateBusinessHours(providerId, businessHours) {
    try {
      const response = await apiService.put(`/providers/${providerId}/business-hours`, {
        businessHours
      });
      return response;
    } catch (error) {
      console.error('Munkaidő frissítése hiba:', error);
      throw error;
    }
  }

}

export default new ProviderService();